import { Box } from '@mui/material';
import {
  CustomTextField,
  VerticalForm,
  HorizontalForm,
} from '../../../common/components';

const GeneralDataSection = ({ selectedProfile, onInputChange, isMobile, editMode }) => {
  if (isMobile) {
    return (
      <Box>
        <VerticalForm>
          <CustomTextField
            label="Nombre"
            name="name"
            value={selectedProfile.name || ''}
            onChange={onInputChange}
            required
            size="medium"
          />
        </VerticalForm>
      </Box>
    );
  }

  return (
    <Box>
      <HorizontalForm withBorder={false} sx={{ p: 1 }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomTextField
            label="Nombre"
            name="name"
            value={selectedProfile.name || ''}
            onChange={onInputChange}
            required
            size="medium"
          />
        </Box>
      </HorizontalForm>
    </Box>
  );
};

export default GeneralDataSection;
